import anime from 'animejs/lib/anime.es.js';
import Cookies from 'js-cookie';

class CookiePopup {
    constructor() {
        this.el = {};
        this.hideNotification = this.hideNotification.bind(this);
        this.expirePeriod = 7;
        this.animation = anime({
          duration: 300,
          autoplay: false,
          easing: 'spring(1, 80, 10, 10)',
          loop: false,
          targets: document.querySelector('.cookie-popup'),
          opacity: 1,
          translateY: ['100%', 0],
          complete: (anim) => {
            anim.reverse()
            if (anim.reversePlayback) {
              this.el.$popup.remove();
              Cookies.set('cookie_consent', true, { expires: this.expirePeriod })
            }
          },
        })
    }
    init() {
      this.cacheDom()
      this.setExpirePeriod()
      this.bindEvents()
      this.animation.play()
    }
    cacheDom() {
        const $ = jQuery;
        this.el.$popup = $('.cookie-popup');
        this.el.$closePopup = this.el.$popup.find('.cookie-consent');
    }
    bindEvents() {
        this.el.$closePopup.on('click', this.hideNotification);
    }
    setExpirePeriod() {
      this.expirePeriod = this.el.$popup.data('expire-period') || this.expirePeriod;
    }
    hideNotification(event) {
      event.preventDefault();
      this.animation.play()
    }
}

export default CookiePopup;


// WEBPACK FOOTER //
// ./scripts/components/CookiePopup.js